/** AppSync AWSDateTime. A blank string is rejected as an invalid value. */
const AWS_DATE_TIME = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d{1,9})?(?:Z|[+-]\d{2}:\d{2})$/;

/**
 * Value safe to store in inspectionStarted / inspectionCompleted.
 * Blank or unparseable queued times fall back so a retry can still send.
 */
export function toAwsDateTime(value: string | null | undefined, fallbackIso?: string): string {
    const fallback = fallbackIso && AWS_DATE_TIME.test(fallbackIso) ? fallbackIso : new Date().toISOString();
    const trimmed = value?.trim() ?? '';
    if (!trimmed) return fallback;

    const parsed = new Date(trimmed);
    if (Number.isNaN(parsed.getTime())) return fallback;
    if (AWS_DATE_TIME.test(trimmed)) return trimmed;
    return parsed.toISOString();
}
